import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Badge } from 'react-bootstrap';

import { IconConnection } from '../../Atoms/Icon';
import { getIsConnected } from '../../Templates/TerminalHome/Wan/connection';

import {
  getConnectedFontSize,
  getDisconnectedFontSize,
} from './connectionSizes';
import { ConnectionsList } from './ConnectionsList';
import styles from './tcmStatus.module.css';

export const TcmStatus = ({
  activeKey,
  size = 'sm',
  className = '',
  selectedMode = '',
  ...props
}) => {
  const connectedSize = getConnectedFontSize(size);
  const disconnectedSize = getDisconnectedFontSize(size);

  const isAlternateOrBackup =
    props[activeKey] && ['alternate', 'backup'].includes(activeKey);
  const isAlternateOrBackupConnected = isAlternateOrBackup
    ? getIsConnected(props[activeKey].connectionStatus)
    : false;

  return (
    <div className="d-inline-flex align-items-center">
      <Badge
        pill
        variant="light"
        className={classNames(
          className,
          styles.tcmBadge,
          'bg-white d-inline-flex border px-1 py-0',
        )}
        style={{ height: size === 'lg' ? '28px' : '' }}
        data-testid="tcmStatusBadge"
      >
        <ConnectionsList
          activeKey={activeKey}
          size={size}
          isAlternateOrBackup={isAlternateOrBackup}
          selectedMode={selectedMode}
          {...props}
        />
      </Badge>
      {isAlternateOrBackup && selectedMode === 'auto' && (
        <span
          className={classNames(
            size === 'lg' ? styles.halfBadgeLg : styles.halfBadge,
            isAlternateOrBackupConnected ? 'badge-success' : 'border',
          )}
        >
          <IconConnection
            name={activeKey}
            isConnected={isAlternateOrBackupConnected}
            isActive
            style={{
              fontSize: isAlternateOrBackupConnected
                ? connectedSize
                : disconnectedSize,
            }}
          />
        </span>
      )}
    </div>
  );
};

TcmStatus.propTypes = {
  activeKey: PropTypes.oneOf(['vsat', 'cell', 'wifi', 'alternate', 'backup']),
  selectedMode: PropTypes.oneOf(['auto', 'manual']),
  size: PropTypes.oneOf(['sm', 'lg']),
  className: PropTypes.string,
  vsat: PropTypes.shape({
    connectionStatus: PropTypes.string.isRequired,
  }),
  cell: PropTypes.shape({
    connectionStatus: PropTypes.string.isRequired,
  }),
  wifi: PropTypes.shape({
    connectionStatus: PropTypes.string.isRequired,
  }),
  alternate: PropTypes.shape({
    connectionStatus: PropTypes.string.isRequired,
  }),
  backup: PropTypes.shape({
    connectionStatus: PropTypes.string.isRequired,
  }),
};
